<template>
  <div class="main-page">
    <section class="page-section">
      <div class="container-fluid">
        <div class="grid justify-content-center">
          <div class="col-12 sm:col-8 md:col-5 lg:col-4 xl:col-3 comp-grid">
            <div class="card nice-shadow-18">
              <div class="text-center mb-1">
                <router-link to="/">
                  <img
                    class=""
                    src="images/logo.png"
                    alt="logo"
                    style="height: 56px"
                  />
                </router-link>
                <div class="text-lg font-bold text-dark mb-2">
                  {{ $t("create_an_account") }}
                </div>
              </div>
              <div class="text-red-500 text-sm mb-3 text-center">
                {{ $t("all_fields_are_required") }} *
              </div>
              <div>
                <form
                  ref="observer"
                  tag="form"
                  @submit.prevent="startSaveRecord()"
                  @reset="resetForm"
                >
                  <div class="grid">
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-12">
                          <check-duplicate
                            v-model="formData.account_username"
                            check-path="components_data/applicants_account_username_exist/"
                            v-slot="checker"
                          >
                            <!-- <div class="field mb-0"> -->
                            <InputText
                              ref="ctrlaccount_username"
                              @blur="checker.check"
                              :loading="checker.loading"
                              v-model.trim="formData.account_username"
                              :label="$t('username')"
                              type="text"
                              :placeholder="$t('username')"
                              class="w-full"
                              maxlength="20"
                              :class="getErrorClass('account_username')"
                            >
                            </InputText>
                            <!-- </div> -->
                            <small
                              v-if="!checker.loading && checker.exist"
                              class="p-error"
                            >
                              {{ $t("not_available") }}</small
                            >
                            <small v-if="checker.loading" class="text-500"
                              >Checking...</small
                            >
                          </check-duplicate>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-12">
                          <check-duplicate
                            v-model="formData.account_email"
                            check-path="components_data/applicants_account_email_exist/"
                            v-slot="checker"
                          >
                            <!-- <div class="field mb-0"> -->
                            <InputText
                              ref="ctrlaccount_email"
                              @blur="checker.check"
                              :loading="checker.loading"
                              v-model.trim="formData.account_email"
                              :label="$t('account_email')"
                              type="email"
                              :placeholder="$t('email')"
                              class="w-full"
                              maxlength="40"
                              :class="getErrorClass('account_email')"
                            >
                            </InputText>
                            <!-- </div> -->
                            <small
                              v-if="!checker.loading && checker.exist"
                              class="p-error"
                            >
                              {{ $t("not_available") }}</small
                            >
                            <small v-if="checker.loading" class="text-500"
                              >Checking...</small
                            >
                          </check-duplicate>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-12">
                          <Password
                            ref="ctrlaccount_password"
                            v-model="formData.account_password"
                            :label="$t('password')"
                            :placeholder="$t('password')"
                            class="w-full"
                            inputClass="w-full"
                            toggleMask
                            :feedback="true"
                            :class="getErrorClass('account_password')"
                          >
                            <template #header>
                              <h6>{{ $t("create_your_new_password") }}</h6>
                            </template>
                            <template #content></template>
                            <template #footer>
                              <Divider />
                              <p class="mt-2">{{ $t("suggestions") }}</p>
                              <ul
                                class="pl-2 ml-2 mt-0"
                                style="line-height: 1.5"
                              >
                                <li>{{ $t("at_least_one_lowercase") }}</li>
                                <li>{{ $t("at_least_one_uppercase") }}</li>
                                <li>{{ $t("at_least_one_numeric_value") }}</li>
                                <li>{{ $t("minimum_8_characters") }}</li>
                              </ul>
                            </template>
                          </Password>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-12">
                          <Password
                            class="w-full"
                            :class="getErrorClass('account_password')"
                            inputClass="w-full"
                            :feedback="false"
                            toggleMask
                            ref="ctrlconfirmaccount_password"
                            v-model="formData.confirm_password"
                            :label="$t('confirm_password')"
                            :placeholder="$t('confirm_password')"
                          />
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="showSubmitButton" class="text-center my-3">
                    <Button
                      type="submit"
                      :label="$t('submit')"
                      :loading="saving"
                      class="w-full p-button-primary py-3"
                    />
                  </div>
                </form>
                <slot :submit="submit" :saving="saving"></slot>
              </div>
            </div>
            <div class="card surface-card nice-shadow-18">
              <div class="">
                <div class="row text-body1 text-center mb-3">
                  {{ $t("already_have_an_account") }}
                </div>
                <div class="row text-center">
                  <router-link to="/">
                    <Button
                      class="p-button-secondary p-button-outlined"
                      :label="$t('login')"
                    />
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { PageMixin } from "../../mixins/page.js";
import { AddPageMixin } from "../../mixins/addpage.js";
import { mapActions, mapGetters, mapState } from "vuex";
import useVuelidate from "@vuelidate/core";
import { required, email, sameAs } from "@vuelidate/validators";
import { i18n } from "../../services/i18n.js";
export default {
  setup() {
    return { v$: useVuelidate() };
  },
  name: "RegisterComponent",
  components: {},
  mixins: [PageMixin, AddPageMixin],
  props: {
    pageName: {
      type: String,
      default: "applicants",
    },
    routeName: {
      type: String,
      default: "applicantsuserregister",
    },
    apiPath: {
      type: String,
      default: "auth/register",
    },
  },
  data() {
    return {
      formData: {
        account_username: "",
        account_email: "",
        account_password: "",
        confirm_password: "",
      },
    };
  },
  computed: {
    pageTitle: {
      get: function () {
        return this.$t("create_an_account");
      },
    },
  },
  validations() {
    let formData = {
      account_username: { required },
      account_email: { required, email },
      account_password: { required },
      confirm_password: {
        sameAsPassword: sameAs(this.formData.account_password),
      },
    };
    return { formData };
  },
  meta() {
    return {
      title: this.pageTitle,
    };
  },
  methods: {
    ...mapActions("applicants", ["saveRecord"]),
    async startSaveRecord() {
      this.submitted = true;
      const isFormValid = !this.v$.$invalid;
      if (!isFormValid) {
        this.flashMsg("Form is invalid", "", "error");
        return;
      }
      this.saving = true;
      let payload = this.normalizedFormData();
      let url = this.apiUrl;
      let data = { url, payload };
      this.saveRecord(data).then(
        (response) => {
          this.saving = false;
          this.resetForm();
          let registrationData = response.data;
          if (registrationData.token && registrationData.user) {
            this.$localStore.saveLoginData(registrationData, false);
            location.href = "/"; //reload page and navigation to home page
          } else {
            this.flashMsg(registrationData.message);
            this.navigateTo(registrationData.nextpage);
          }
        },
        (response) => {
          this.saving = false;
          this.showPageRequestError(response);
        }
      );
    },
    resetForm() {
      this.formData = {
        // account_username: "",
        // account_email: "",
        account_password: "",
        confirm_password: "",
      };
      requestAnimationFrame(() => {
        this.$refs.observer.reset();
      });
      //this.$EventBus.$emit("resetForm");
    },
    getErrorClass(field) {
      return {
        "p-invalid": this.v$.formData[field].$invalid && this.submitted,
      };
    },
  },
  async mounted() {},
  async created() {},
};
</script>
<style scoped></style>
